import React from 'react';
import '../App.css';
import { useLocation } from 'react-router-dom';

const ErrorPage = () => {
    const location = useLocation();
    const { header, message, linkPrefix, linkText, linkHref, linkSuffix, logo } = location.state || {};
    const headerBgColor = linkHref && linkHref.toLowerCase().includes("vacation") ? "#33c590" : "white";


    return (
        <div className="ErrorPage">
            <header className="shadow-md p-10 text-center relative" style={{ backgroundColor: headerBgColor }}>
                <a href={linkHref} rel="noopener noreferrer">
                    <img
                        src={logo || "https://agents.travelleaders.com/revImg/LogoTL_59.png"}
                        alt="Agency Logo"
                        className="text-center"
                    />
                </a>
            </header>

            <div className="bg-white shadow-md p-20 mt-24 mb-10 w-11/12 max-w-2xl mx-auto text-center relative">
                <div className="relative">
                    <h1 className="text-3xl mb-2 pb-4 text-tlBlue">{header || "Oops! Something went wrong."}</h1>
                    <h2 className="text-lg mb-2">
                        {message ? (
                            message
                        ) : (
                            <>
                                Please try again in a few minutes.
                                <br />
                                If the error persists,{" "}
                            </>
                        )}
                        {linkPrefix && `${linkPrefix} `}
                        <a
                            className="text-lg mb-2 text-tlBlue"
                            href={linkHref || "https://travelleaders.com/contact_us"}
                            target="_blank"
                            rel="noopener noreferrer"
                            id="lnkFindAgents"
                        >
                            {linkText || "please contact us"}
                        </a>
                        {linkSuffix && ` ${linkSuffix}`}
                    </h2>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
